// eslint-disable-next-line import/prefer-default-export
export enum LoadingVariant {
  DOT = 'dot',
  LINEAR = 'linear'
}
